import axiosInstance from '../config/axios.js';

const API_BASE = '/billings';

const billingService = {
  // Get all billings with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all billings without pagination
  getAllBillings: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get billing by ID
  getById: async (billingId) => {
    const response = await axiosInstance.get(`${API_BASE}/${billingId}`);
    return response.data;
  },

  // Get pending services for a client across all service types
  getPendingServices: async (clientId) => {
    const response = await axiosInstance.get(`${API_BASE}/pending-services`, {
      params: { client_id: clientId }
    });
    return response.data;
  },

  // Create new billing
  create: async (billingData) => {
    const response = await axiosInstance.post(API_BASE, billingData);
    return response.data;
  },

  // Update billing
  update: async (billingId, billingData) => {
    const response = await axiosInstance.put(`${API_BASE}/${billingId}`, billingData);
    return response.data;
  },

  // Update billing payment status
  updateStatus: async (billingId, status) => {
    const response = await axiosInstance.patch(`${API_BASE}/${billingId}/status`, {
      status
    });
    return response.data;
  },

  // Delete billing
  delete: async (billingId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${billingId}`);
    return response.data;
  },

  // Generate invoice PDF
  generateInvoice: async (billingId) => {
    const response = await axiosInstance.get(`${API_BASE}/${billingId}/invoice`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Export CSV for selected billings
  exportCSV: async (billingIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: billingIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Send invoice via email
  sendInvoiceEmail: async (billingId) => {
    const response = await axiosInstance.post(`${API_BASE}/${billingId}/send-invoice`);
    return response.data;
  },

  // Get next auto-generated billing ID
  getNextBillingId: async () => {
    const response = await axiosInstance.get(`${API_BASE}/next-id`);
    return response.data;
  },
};

export default billingService;